<viavi-table
  *ngIf="show"
  [tableConfigurations]="table"
  [isActionEnabled]="false"
  [cartPage]="true"
  (removeData)="removeCart($event)"
  (removeAllRows)="removeAllRows($event)"
>
</viavi-table>
